<template>
  <div style="min-height:100%;background-color:#fff">
    <header>
      <div v-if="has_reward_banner && banner_config" class="guarantee-banner">
        <img-txt-link :form-item="banner_config" v-if="banner_config.type === 'img-txt-link'"></img-txt-link>
      </div>
      <p class="title">{{$t('choose_sign_way')}}</p>
      <p class="desc">{{$t("sign_desc")}}</p>
    </header>
    <main>
      <div :class="{phone:1,filled:num}">
        <span @click="focusInput">{{phoneCountryCode}}</span>
        <input
          ref="phone_input"
          autocomplete="off"
          type="tel"
          maxlength="100"
          v-model="num"
          @input="formatCell"
          :placeholder="$t('sign_placeholder')"
        />
      </div>
      <div
        :class="{legal:1,checked:_law_checked,vamos_checked:_law_checked&&oasis}"
        @click="checkLaw"
      >
        <span>{{$t("click_legal")}}</span>
        <span :class="{link:1,vamos_link:oasis}" @click.stop="goLink">{{$t("legal_desc")}}</span>
      </div>
      <p
        :class="{join_btn:1,active:valid,showWa:_showWa&&!oasis,vamos_active:valid&&oasis}"
        @click="login"
      >{{$t("join_99_btn")}}</p>
      <div class="split" v-show="_showWa&&!oasis">
        <span>{{$t("or")}}</span>
      </div>
      <p
        v-show="_showWa&&!oasis"
        class="whatsapp_btn"
        @click="goWhatsapp"
      >{{$t("join_whatsapp_btn")}}</p>
    </main>
    <footer v-if="!oasis">
      <p class="title">{{$t("income_title1")+$t("income_title2")}}</p>
      <div class="item">
        <img-v3 :src="require('../../images/icon_income@3x.png')" />
        <div class="item_detail">
          <p class="tip1">{{$t('login_intro_title_1')}}</p>
          <p class="tip2">{{$t('login_intro_desc_1')}}</p>
        </div>
      </div>
      <div class="item">
        <img-v3 :src="require('../../images/icon_payfast@3x.png')" />
        <div class="item_detail">
          <p class="tip1">{{$t('login_intro_title_2')}}</p>
          <p class="tip2">{{$t('login_intro_desc_2')}}</p>
        </div>
      </div>
      <div class="item">
        <img-v3 :src="require('../../images/icon_99best@3x.png')" />
        <div class="item_detail">
          <p class="tip1">{{$t('login_intro_title_3')}}</p>
          <p class="tip2">{{$t('login_intro_desc_3')}}</p>
        </div>
      </div>
    </footer>
    <template v-else>
      <div class="oasis_split"></div>
      <img-v3 class="oasis_img" :src="require('../../images/H5@2x.png')" />
    </template>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import { showLoadingToast, showToast, showAlertDialog } from "../../tools/Tip";
import { LOGIN_CONFIG } from "../../tools/constant";
import { getEnd, fireBase } from "../../tools/utils";
import { post, get } from "../../tools/request";
import ImgTxtLink from "../base/img-txt-link.vue";

export default {
  components: { ImgTxtLink },
  data() {
    return {
      num: "",
      has_reward_banner: false,
      banner_config: {}
    };
  },
  computed: {
    ...mapState(["_showWa", "_law_checked", "_phone_focus", "_ticket"]),
    country() {
      return this.params.get("location_country");
    },
    oasis() {
      return this.params.get("business_line") === "oasis";
    },
    params() {
      return new URLSearchParams(location.search);
    },
    phoneCountryCode() {
      return LOGIN_CONFIG[this.country].country_calling_code;
    },
    valid() {
      return this.num;
    }
  },
  mounted() {
    try {
      Omega.trackEvent("login_homepage", "", {
        channel: this.params.get("channel"),
        oid: Omega.getOmgid(),
        end: getEnd(),
        client_user_agent: navigator.userAgent, // 必须
        // client_ip_address: '', // 可选
        fbp: this.$cookies.get('_fbp'), // 可选，可能有多个，需要和domain匹配
        fbc: this.$cookies.get('_fbc'), // 可选，可能有多个或没有，需要和domain匹配
      });
      gtm({
        'event': 'pageview',
        'error': 'false'})
    } catch (e) {}
    // this.setState({
    //   _help_icon: true
    // });
    // @210705 login保底奖实验下期
    // @20210915 BR login保底奖接保底奖平台
    this.getRewardConf();
  },
  methods: {
    ...mapMutations(["setState"]),
    focusInput() {
      this._phone_focus && this.$refs.phone_input.focus();
    },
    formatCell() {
      this.num = this.num.replace(/\D/g, "");
    },
    checkLaw() {
      this.setState({
        _law_checked: !this._law_checked
      });
    },
    goLink() {
      location.href = LOGIN_CONFIG[this.country].law_url;
    },
    //passport登录
    login(cate) {
      try {
        // @20211209 原有埋点go_99_login已经搜索不到，新替换埋点ibt_onboarding_oldsubmit_ck
        Omega.trackEvent("ibt_onboarding_oldsubmit_ck", "", { phone: this.num });
        gtm({
          'event': 's1PassportRegister',
          'PhoneNumber': 'invalid',
          'Country': 'BR',
          'RegisterWith': '99',
          'error': 'false'})
      } catch (e) {}
      if (!this.valid) {
        return;
      }
      if (!this._law_checked) {
        showToast(this, {
          type: "warn",
          txt: this.$t(
            "Global_Driver_PASSPORT_SKIP_AGREEMENT_CHECK_Selection_JOeI"
          )
        });
        return;
      }
      try{
        gtm({
          'event': 's1PassportRegister',
          'PhoneNumber': 'valid',
          'Country': 'BR',
          'RegisterWith': '99',
          'error': 'false'})
      }catch(e){}
      showLoadingToast(this, this.$t("加载中"), 1500);
      login.checkPhone(
        this.num,
        response => {
          const { ticket, cell, uid } = response;
          this.setState({ _ticket: ticket, _cell: cell, _uuid: uid });
          //@20211217 BR新增fleet业务
          if (this.params.get("helpDriverReg") == 1) {
            //fleet 端 车头帮司机注册并绑定的逻辑
            this.handleFleet();
          } else {
            this.$router.replace({ name: "home" });
          }
          try{
            this.oasis&&signup_gtag_report_conversion();
            fireBase("tone_p_x_login_success_sw");
          }catch(e){
            console.log('track error ',e)
          }
        },
        error => {
          console.log(error);
        }
      );
    },
    handleFleet() {
      showLoadingToast(this);
      let up = new URLSearchParams(location.search);
      up.set("ticket", this._ticket);
      get(process.env.DRIVER_CHECK, {
        params: up,
      })
        .then((data) => {
          //  已注册能绑定 => bindTips
          this.$router.replace({
            name: `bindTipMx`,
            params: {
              driverInfo: data.driver_info,
            },
          });
        })
        .catch((e) => {
          //  未注册 => 跳转到注册页,20002
          const { errmsg, errno } = e;
          if (+errno === 20002) {
            this.$router.replace({ name: "home" });
          } else if (+errno === 90002) {
            // @20210709 坏账司机不可以注册
            showAlertDialog(this, this.$t("Fleet_control_The_driver_KRsg"));
          } else {
            //  已注册不能绑定 => 错误提示,错误码不等于0且不等于20002
            showAlertDialog(this, errmsg);
            login.logout(
              () => console.log("logout success"),
              (e) => console.log(e)
            );
          }
        })
        .finally((x) => this.toast.hide());
    },
    goWhatsapp() {
      try {
        Omega.trackEvent("go_whatsapp", "", { phone: this.num });
        gtm({
          'event': 's1PassportRegister',
          'PhoneNumber': 'valid',
          'Country': 'BR',
          'RegisterWith': 'WhatsApp',
          'error': 'false'})
      } catch (e) {}
      let up = new URLSearchParams(location.search);
      up.delete("ticket");
      up.delete("token");
      up.delete("uid");
      up.set("phone", this.phoneCountryCode + this.num);
      up.set("campaign", "17");
      location.href = `https://whatsapp.99app.com?${up}`;
    },
    getRewardConf() {
      showLoadingToast(this)
      let up = new URLSearchParams(location.search);
      up.set('lat', -21.5719)
      up.set('lng', -52.00091)
      post(process.env.LOGIN_BANNER_INFO, up)
        .then((res) => {
          this.has_reward_banner = res.is_show_banner;
          if (res.is_show_banner && res.passport_reward_banner) {
            let passport_reward_banner = { ...res.passport_reward_banner };
            let reward_conf = { ...res.reward_conf }
            let text = passport_reward_banner.title || '';
            let rides_reward = (reward_conf.rides_reward || []).pop() || {};
            passport_reward_banner.title = reward_conf.areaId ?
                                          text.replace(/\{\{city\}\}/, reward_conf.areaName || '').replace(/\{\{fee_amount\}\}/, () => rides_reward.reward || '')
                                          : '';
            this.banner_config = passport_reward_banner;
          }
        })
        .catch((err) => console.log(err))
        .finally(() => {
          this.toast.hide()
        });
    }
  }
};
</script>
<style lang="less" scoped>
header {
  width: 6.83rem;
  padding-top: 0.5rem;
  margin: 0 auto 1.25rem auto;
  .guarantee-banner {
    width: 100%;
    .img-container {
      margin-top: 0;
    }
  }
  .title {
    margin-bottom: 0.21rem;
    font-size: 0.45rem;
    font-weight: bold;
    color: #333;
  }
  .desc {
    font-size: 0.29rem;
    color: #666;
  }
}
main {
  width: 6.83rem;
  margin: auto;
  .phone {
    display: flex;
    align-items: center;
    height: 0.75rem;
    border-bottom: 1px #ccc solid;
    span {
      margin-right: 0.29rem;
      font-size: 0.375rem;
      font-weight: bold;
      color: #333;
    }
    input {
      width: 5.58rem;
      height: 0.6rem;
      font-size: 0.5rem;
    }
  }
  .filled {
    border-bottom: 1px #666 solid;
  }
  .legal {
    position: relative;
    height: 0.33rem;
    padding-left: 0.42rem;
    margin: 0.3rem 0 0.63rem 0;
    font-size: 0.25rem;
    line-height: 0.33rem;
    color: #999;
    .link {
      color: #2697ff;
    }
    .vamos_link {
      color: #ff7424;
    }
    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      width: 0.29rem;
      height: 0.29rem;
      background: url("../../images/br-law-uncheck@3x.png") no-repeat;
      background-size: 100%;
    }
    &.checked {
      &::before {
        background: url("../../images/br-law-checked@3x.png") no-repeat;
        background-size: 100%;
      }
    }
    &.vamos_checked {
      &::before {
        background: url("../../images/br-vamos-checked@3x.png") no-repeat;
        background-size: 100%;
      }
    }
  }
  .join_btn {
    height: 1.125rem;
    margin-bottom: 0.8rem;
    font-size: 0.375rem;
    line-height: 1.125rem;
    color: #999;
    text-align: center;
    background: #ccc;
    border-radius: 0.04rem;
  }
  .active {
    color: #323233;
    background: #ffe600;
  }
  .vamos_active {
    font-weight: bold;
    background: linear-gradient(135deg, #fff362 0%, #fd9728 100%);
  }
  .showWa {
    margin-bottom: 0;
  }
  .split {
    position: relative;
    margin: 1.322rem 0 0.69rem 0;
    font-size: 0.33rem;
    color: #ccc;
    text-align: center;
    span {
      display: inline-block;
      position: relative;
      z-index: 9;
      width: 1rem;
      background-color: #fff;
    }
    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 50%;
      width: 100%;
      height: 0;
      border-bottom: 1px solid rgba(0, 0, 0, 0.08);
      transform: scaleY(0.5);
    }
  }
  .whatsapp_btn {
    height: 1.125rem;
    margin-bottom: 0.625rem;
    font-size: 0.375rem;
    line-height: 1.125rem;
    color: #00e676;
    text-align: center;
    border: 1px solid #00e676;
    border-radius: 0.04rem;
  }
}
footer {
  position: relative;
  padding: 0.41rem 0.33rem 0 0.33rem;
  &::before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 7.5rem;
    height: 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
    transform: scaleY(0.5);
  }
  p.title {
    padding-bottom: 0.41rem;
    font-size: 0.45rem;
    font-weight: bold;
    color: #333;
  }
  .item {
    display: flex;
    align-items: center;
    padding-bottom: 0.291rem;
    img {
      flex-shrink: 0;
      width: 1.14rem;
      height: 1.14rem;
      margin-right: 0.29rem;
    }
    .item_detail {
      .tip1 {
        margin-bottom: 0.12rem;
        font-size: 0.375rem;
        color: #333;
      }
      .tip2 {
        font-size: 0.29rem;
        color: #666;
      }
    }
    &:last-child {
      padding-bottom: 0.625rem;
    }
  }
}
.oasis_img {
  display: block;
  box-sizing: border-box;
  width: 100%;
}
.oasis_split {
  width: 6.78rem;
  height: 1px;
  margin: auto;
  margin-top: -0.2rem;
  opacity: 0.1;
  background: #000000;
}
</style>

